import classNames from 'classnames';
import * as React from 'react';

export interface TableBodyProps {
  body?: React.ReactNode[];
  className?: string;
  header?: React.ReactNode;
  size: 'lg' | 'md' | 'sm';
}

export const TableBody: React.VFC<TableBodyProps> = ({
  body,
  className,
  header,
  size,
}) => (
  // eslint-disable-next-line @blueprintjs/html-components
  <table
    className={classNames(
      className,
      'vb-data-table-body',
      `vb-data-table-body-size--${size}`
    )}
  >
    <thead>
      <tr>{header}</tr>
    </thead>
    <tbody>
      {body?.map((cells, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={idx}>{cells}</tr>
      ))}
    </tbody>
  </table>
);
